/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Ad_Render_Failed_ToastInputs */

const en_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to render text-to-speech: ${i?.error}`)
};

const fr_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec du rendu en synthese vocale : ${i?.error}`)
};

const de_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Rendern von Text-zu-Sprache: ${i?.error}`)
};

const it_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile eseguire il rendering del testo in voce: ${i?.error}`)
};

const ru_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось выполнить преобразование текста в речь: ${i?.error}`)
};

const es_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al convertir texto a voz: ${i?.error}`)
};

const zh_cn2_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`文本转语音渲染失败：${i?.error}`)
};

const ja_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`テキスト読み上げのレンダリングに失敗しました: ${i?.error}`)
};

const hi_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टेक्स्ट-टू-स्पीच को रेंडर करने में विफल: ${i?.error}`)
};

const pt_pt2_shortcut_keys_ad_render_failed_toast = /** @type {(inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao converter texto em fala: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to render text-to-speech: {error}" |
*
* @param {Shortcut_Keys_Ad_Render_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ad_render_failed_toast = /** @type {((inputs: Shortcut_Keys_Ad_Render_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ad_Render_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_ad_render_failed_toast(inputs)
	if (locale === "de") return de_shortcut_keys_ad_render_failed_toast(inputs)
	if (locale === "it") return it_shortcut_keys_ad_render_failed_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_ad_render_failed_toast(inputs)
	if (locale === "es") return es_shortcut_keys_ad_render_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_ad_render_failed_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_ad_render_failed_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_ad_render_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_ad_render_failed_toast(inputs)
	return en_shortcut_keys_ad_render_failed_toast(inputs)
});